import script from "./ManagementPortDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagementPortDetails.vue?vue&type=script&setup=true&lang=js"

import "./ManagementPortDetails.vue?vue&type=style&index=0&id=1bdf14f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bdf14f8"]])

export default __exports__